<template>
    <div class="create_dk_img">
        <Alert type="success">下图所有信息条目均可自助填写</Alert>
        <div>
            <Button type="primary" @click="to_img">点击截图</Button>
        </div>
        <div class="jt_img" v-show="img_url">
            <img :src="img_url" alt />
            <Button type="primary" @click="open_tab">新标签页打开</Button>
        </div>
        <div class="bank_info info_bd" id="bank_info" v-if="$route.query.type ==2">
            <div class="info">
                <input class="name" value="金融网贷商业险" type="text" />
                <input class="dkgy1" :value="data.web_title + data.order_num" type="text" />
                <input class="dkgy2" :value="'贷款' + data.money + '元整'" type="text" />
                <input class="tbr" v-model="data.real_name" type="text" />
                <input class="tbje" :value="data.money + '元整'" type="text" />
                <input class="bxtx" :value="data.date2" type="text" />
                <input class="bdzt" value="未生效" type="text" />
                <input class="bdlx" value="电子 保单" type="text" />
            </div>
        </div>
        <div class="bank_info info_dk" id="bank_info" v-if="$route.query.type ==1">
            <div class="trans_company">您好，{{data.trans_company}}</div>
            <div class="info">
                <tbody>
                    <tr>
                        <td width="180" align="right">转账批次号：</td>
                        <td>
                            <input
                                v-model="data.order_num"
                                type="text"
                                class="inpMain"
                                size="40"
                                name="name"
                                style="border:solid #ccc 0px;color:#666666"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td width="180" align="right">转出单位：</td>
                        <td>
                            <input
                                v-model="data.trans_company"
                                type="text"
                                class="inpMain"
                                size="40"
                                name="name"
                                style="border:solid #ccc 0px;color:#666666"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td width="180" align="right">转出账户：</td>
                        <td>
                            <input
                                value="16602808015501"
                                type="text"
                                class="inpMain"
                                size="40"
                                name="name"
                                style="border:solid #ccc 0px;color:#666666"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td width="180" align="right">转出账号地区：</td>
                        <td>
                            <input
                                value="北京"
                                type="text"
                                class="inpMain"
                                size="40"
                                name="name"
                                style="border:solid #ccc 0px;color:#666666"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td width="180" align="right">收款人姓名：</td>
                        <td>
                            <input
                                v-model="data.real_name"
                                type="text"
                                class="inpMain"
                                size="40"
                                name="name"
                                style="border:solid #ccc 0px;color:#666666"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td width="180" align="right">收款银行：</td>
                        <td>
                            <input
                                v-model="data.open_bank"
                                type="text"
                                class="inpMain"
                                size="40"
                                name="name"
                                style="border:solid #ccc 0px;color:#666666"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td width="180" align="right">收款账户：</td>
                        <td>
                            <input
                                v-model="data.bank_num"
                                type="text"
                                class="inpMain"
                                size="40"
                                name="name"
                                style="border:solid #ccc 0px;color:#666666"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td width="180" align="right">币种：</td>
                        <td>
                            <input
                                value="人民币"
                                type="text"
                                class="inpMain"
                                size="40"
                                name="name"
                                style="border:solid #ccc 0px;color:#666666"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td width="180" align="right">转账金额：</td>
                        <td>
                            <input
                                v-model="data.money"
                                type="text"
                                class="inpMain"
                                size="40"
                                name="name"
                                style="border:solid #ccc 0px;color:#666666"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td width="180" align="right">转账时间：</td>
                        <td>
                            <input
                                v-model="data.date"
                                type="text"
                                class="inpMain"
                                size="40"
                                name="name"
                                style="border:solid #ccc 0px;color:#666666"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td width="180" align="right">转账类型：</td>
                        <td>
                            <input
                                value="签约金融企业--网贷放款预约转账"
                                type="text"
                                class="inpMain"
                                size="40"
                                name="name"
                                style="border:solid #ccc 0px;color:#666666"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td width="180" align="right">执行方式：</td>
                        <td>
                            <input
                                value="实时到账"
                                type="text"
                                class="inpMain"
                                size="40"
                                name="name"
                                style="border:solid #ccc 0px;color:#666666"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td width="180" align="right">状态：</td>
                        <td>
                            <input
                                value="银行卡异常"
                                type="text"
                                class="inpMain"
                                size="40"
                                name="name"
                                style="border:solid #ccc 0px;color:#008000"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td width="180" align="right">银行备注：</td>
                        <td>
                            <input
                                value
                                type="text"
                                class="inpMain"
                                size="40"
                                name="name"
                                style="border:solid #ccc 0px;color:#008000"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td width="180" align="right">处理结果：</td>
                        <td>
                            <input
                                value="未处理"
                                type="text"
                                class="inpMain"
                                size="40"
                                name="name"
                                style="border:solid #ccc 0px;color:#ff0000"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td width="180" align="right">用户备注：</td>
                        <td>
                            <input
                                value
                                type="text"
                                class="inpMain"
                                size="40"
                                name="name"
                                style="border:solid #ccc 0px;color:#008000"
                            />
                        </td>
                    </tr>
                </tbody>
            </div>
        </div>
    </div>
</template>
<script>
import html2canvas from "html2canvas";
export default {
    data() {
        return {
            img_url: "",
            data: {}
        };
    },
    mounted() {
        this.get_data();
    },
    methods: {
        get_data() {
            this.$get(this.$path.transfer_screenshot, {
                order_id: this.$route.query.order_id
            }).then(res => {
                if (res.success) {
                    this.data = res.data;
                    const date = new Date(res.data.date);
                    this.data.date2 = date.toLocaleDateString() + '-' + new Date(date.setFullYear(date.getFullYear())).toLocaleDateString();
                }
            });
        },
        to_img() {
            let htmlDom = document.querySelector("#bank_info");
            html2canvas(htmlDom, {
                allowTaint: false, //允许污染
                taintTest: true, //在渲染前测试图片(没整明白有啥用)
                useCORS: true, //使用跨域(当allowTaint为true时这段代码没什么用,下面解释)
                background: "#fff"
            }).then(canvas => {
                this.img_url = canvas.toDataURL("image/jpeg", 1.0);
                // callBack(); //回调
            });
        },
        open_tab() {
            window
                .open()
                .document.write(`<div><img src="${this.img_url}"/></div>`);
        }
    }
};
</script>
<style lang="scss" scoped>
.create_dk_img {
    .jt_img {
        margin-top: 10px;
        margin-bottom: 10px;
        img {
            width: 200px;
            height: 140px;
        }
    }
    .info_bd {
        background: url("/static/bill.jpg");
        width: 1442px;
        height: 622px;
        position: relative;
        input {
            color: #2f2f2f;
            font-weight: bold;
        }
        .name {
            position: absolute;
            top: 328px;
            left: 174px;
            width: 110px;
        }
        .dkgy1 {
            position: absolute;
            top: 319px;
            left: 305px;
            width: 200px;
            text-align: center;
        }
        .dkgy2 {
            position: absolute;
            top: 337px;
            left: 305px;
            width: 200px;
            text-align: center;
        }
        .tbr {
            position: absolute;
            top: 326px;
            left: 519px;
            width: 56px;
            text-align: center;
        }
        .tbje {
            position: absolute;
            top: 326px;
            left: 609px;
            width: 115px;
            text-align: center;
        }
        .bxtx {
            position: absolute;
            top: 326px;
            left: 783px;
            width: 213px;
            text-align: center;
        }
        .bdzt {
            position: absolute;
            top: 326px;
            left: 1036px;
            width: 70px;
            text-align: center;
        }
        .bdlx {
            position: absolute;
            top: 326px;
            left: 1123px;
            width: 70px;
            text-align: center;
        }
    }
    .info_dk {
        background: url("/static/bank.jpg");
        width: 1000px;
        height: 825px;
        padding-top: 220px;
        padding-left: 426px;
    }
    .bank_info {
        font-size: 14px;
        background-size: 100% 100%;
        position: relative;
        .trans_company {
            position: absolute;
            top: 41px;
            left: 408px;
            color: #535353;
            font-weight: bold;
            font-size: 12px;
        }
    }
    .info {
        tr {
            height: 28px;
            td:nth-child(1) {
                color: #000000;
            }
        }
    }
    .ivu-btn {
        margin-bottom: 10px;
    }
    input {
        outline: none;
        border: none;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/borrow/create_dk_img.vue